import {
  MetaCalendario,
  ReceitaDespesa,
} from "../model/PlanoDeTrabalho/PlanoAplicacao";

const convertCalendario = (
  receitaOrgao: MetaCalendario[],
  receitaOSC: MetaCalendario[],
  despesaOrgao: MetaCalendario[],
  despesaOSC: MetaCalendario[]
): ReceitaDespesa[] => {
  const result: ReceitaDespesa[] = [];
  const converter = (
    calendario: MetaCalendario[],
    orgao: string,
    tipo: string
  ) => {
    calendario.forEach((meta) => {
      meta.meses.forEach((mesValue, index) => {
        if (mesValue > 0) {
          result.push({
            meta_execucao_fisico_id: meta.metaFisica,
            ano: meta.ano,
            mes: index + 1,
            etapa: meta.etapa,
            fase: meta.fase,
            orgao: orgao,
            tipo: tipo,
            total_meta: mesValue,
          });
        }
      });
    });
  };
  converter(receitaOrgao, "orgao", "receita");
  converter(receitaOSC, "osc", "receita");
  converter(despesaOrgao, "orgao", "despesa");
  converter(despesaOSC, "osc", "despesa");

  return result;
};
export default convertCalendario;
